import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = import.meta.env.VITE_API_URL;

export default function AcceptInvite() {
  const q = new URLSearchParams(useLocation().search);
  const token = q.get("token") || "";
  const nav = useNavigate();

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    if (!token) setMsg("Invalid invite.");
  }, [token]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    const res = await fetch(`${API}/invite/accept`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, name, password }),
      credentials: "include",
    });
    if (res.ok) {
      setOk(true);
      setMsg("Invite accepted. You can now log in.");
      setTimeout(() => nav("/"), 1200);
    } else {
      const j = await res.json().catch(() => ({}));
      setMsg(j.error || "Failed to accept invite");
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <form onSubmit={submit} className="bg-white p-6 rounded shadow w-full max-w-md space-y-3">
        <h1 className="text-xl font-semibold">Accept Invite</h1>
        {msg && <div className={ok ? "text-green-700" : "text-red-600"}>{msg}</div>}
        <input type="hidden" value={token} />
        <div>
          <label className="block text-sm mb-1">Your name</label>
          <input className="w-full border rounded px-3 py-2" value={name} onChange={e=>setName(e.target.value)} />
        </div>
        <div>
          <label className="block text-sm mb-1">Set a password</label>
          <input type="password" className="w-full border rounded px-3 py-2" value={password} onChange={e=>setPassword(e.target.value)} required />
        </div>
        <button className="w-full bg-blue-600 text-white py-2 rounded">Create account</button>
      </form>
    </div>
  );
}
